import Strumenti from './Strumenti';
export default Strumenti;
